(ns common.schema.entities.investment-reservation-type
  (:require
   [common.schema.schema-utils :as su]
   [common.schema.entities.investment-reservation :as investment-reservation]))


(def schema
  (vec
   (concat
    (su/text-simple-field :investment-reservation-type/title
                          "Investment reservation type"
                          {:authorization su/access-admin-user})

    (su/keyword-multi-field :investment-reservation-type/enabled-fields
                            "Enabled fields"
                            investment-reservation/admin-configurable-fields-options
                            {:authorization su/access-admin-user})

    (su/boolean-field :investment-reservation-type/subtract-from-dry-powder
                      "Subtract from dry powder"
                      {:authorization su/access-admin-user}))))
